import { Open24Regular } from '@fluentui/react-icons'
import { FadeIn } from './AnimateIn'
import { Text } from './Text'

interface Props {
  index: number
  children: string
  url: string
}

export default function Reference({ index, children, url }: Props) {
  return (
    <FadeIn delay={index * 0.05 + 0.2} className='w-full md:w-[calc(50%-8px)] lg:w-full'>
      <a
        href={url}
        className='hover:text-[#007AFF] flex flex-row flex-1 items-center p-[24px] gap-[8px] bg-white group rounded-[8px] hover:bg-blue-100 transition-colors'
        target='_blank'
        rel='noreferrer'
      >
        <Text.Body className='flex flex-1'>{children}</Text.Body>
        <Open24Regular className='opacity-40 group-hover:opacity-100 transition-opacity' />
      </a>
    </FadeIn>
  )
}
